import type { BeholdFeed } from "~/utils/behold-feed.server";

function InstagramIcon({ className }: { className?: string }) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			className={className}
			aria-hidden="true"
		>
			<rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
			<path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
			<line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
		</svg>
	);
}

export default function InstagramFeed({ feed }: { feed: BeholdFeed }) {
	if (!feed?.posts?.length) return null;

	return (
		<section className="container px-4 md:px-6">
			<div className="mb-4 flex items-center gap-3">
				<a
					href={`https://www.instagram.com/${feed.username}`}
					target="_blank"
					rel="noopener noreferrer"
					className="font-light text-3xl text-primary tracking-tighter hover:underline sm:text-4xl md:text-5xl"
				>
					Følg oss på Instagram –
					@{feed.username}
				</a>
			</div>
			<div className="scrollbar-hide -mx-4 flex snap-x snap-mandatory flex-nowrap gap-4 overflow-x-auto py-1 md:mx-0 md:grid md:grid-cols-3 md:flex-wrap md:gap-4 md:p-1 lg:grid-cols-6">
				{feed.posts.slice(0, 6).map((post) => (
					<a
						key={post.id}
						href={post.permalink}
						target="_blank"
						rel="noopener noreferrer"
						className="group relative w-[45%] shrink-0 grow-0 basis-auto snap-start overflow-hidden rounded-lg first:ml-4 md:w-auto md:first:ml-0"
					>
						<div className="aspect-square overflow-hidden rounded-lg">
							<img
								src={
									post.mediaType === "VIDEO"
										? post.sizes.medium.mediaUrl
										: post.sizes.medium.mediaUrl
								}
								alt={post.prunedCaption || "Instagram post"}
								loading="lazy"
								className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
							/>
						</div>
						<div className="pointer-events-none absolute inset-0 flex items-center justify-center rounded-lg bg-black/0 transition-colors duration-300 group-hover:bg-black/40">
							<div className="flex flex-col items-center gap-2 px-3 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
								<InstagramIcon className="h-5 w-5 text-white" />
								{post.prunedCaption && (
									<p className="line-clamp-3 text-center text-white text-xs leading-tight">
										{post.prunedCaption}
									</p>
								)}
							</div>
						</div>
					</a>
				))}
			</div>
		</section>
	);
}
